import { Button, Box, Skeleton } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { usePartyManager } from './PartyManagerContext';
import {
  POSSIBLE_SOURCES,
  EDIT_SOURCE,
  CODEMETA_SOURCE,
} from './partyManagerUtils';
import 'dayjs/locale/de';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);
dayjs.locale('de');

const DateField = ({ fieldKey, label, minDate, maxDate }) => {
  const {
    partyData,
    handleFieldChange,
    handleCycleSource,
    getAvailableSources,
    isPartyManagerLoading,
  } = usePartyManager();

  const fieldState = partyData[fieldKey];
  if (!fieldState) {
    return null;
  }

  const availableSources = getAvailableSources(fieldKey);
  const displayValue =
    fieldState.selected === 'edit'
      ? fieldState.edit
      : fieldState[fieldState.selected];

  const getButtonIcon = () => {
    const selectedSource = fieldState.selected;
    if (selectedSource === 'edit') return EDIT_SOURCE.icon;
    if (selectedSource === 'codemeta') {
      return (
        <img
          src={CODEMETA_SOURCE.icon}
          alt={CODEMETA_SOURCE.name}
          style={{ width: '24px', height: '24px' }}
        />
      );
    }
    const sourceInfo = POSSIBLE_SOURCES[selectedSource];
    if (sourceInfo?.icon) {
      return (
        <img
          src={sourceInfo.icon}
          alt={sourceInfo.name}
          style={{ width: '24px', height: '24px' }}
        />
      );
    }
    return '?';
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {isPartyManagerLoading ? (
        <Skeleton variant="rounded" width="100%" height={40} />
      ) : (
        <>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={label}
              value={displayValue ? dayjs(displayValue) : null}
              onChange={(newDate) => {
                const isoString = newDate ? newDate.toISOString() : null;
                handleFieldChange(fieldKey, isoString);
              }}
              format="DD.MM.YYYY"
              minDate={minDate ? dayjs(minDate) : undefined}
              maxDate={maxDate ? dayjs(maxDate) : undefined}
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
              sx={{
                '& .MuiInputBase-input': {
                  color: 'rgba(0, 0, 0, 0.87)',
                },
                '& .MuiInputLabel-root': {
                  color: 'rgba(0, 0, 0, 0.38)',
                  '&.MuiInputLabel-shrink': {
                    color: 'rgba(0, 0, 0, 0.87)',
                  },
                },
              }}
            />
          </LocalizationProvider>

          {availableSources.length > 1 && (
            <Button
              title={`Quelle wechseln: Aktuell ${fieldState.selected}. Verfügbar: ${availableSources.join(', ')}`}
              sx={{
                width: '40px',
                height: '40px',
                minWidth: '40px',
                maxWidth: '40px',
              }}
              onClick={() => handleCycleSource(fieldKey)}
              variant="outlined"
            >
              {getButtonIcon()}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default DateField;
